import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/technicalCards'

class TechnicalCardDataService extends RestApiDataService {

}

export default new TechnicalCardDataService(BASE_ENTITY_URL)
